import { IconProps } from "./HomeIcon";

const ActiveAiIcon = ({ color = "#0AC4B2" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0007 0.5C12.9908 0.5 13.7943 1.30355 13.7943 2.29364V10.0661H10.207V2.29364C10.207 1.30355 11.0106 0.5 12.0007 0.5Z"
        fill={color}
      />
      <path
        d="M0.554265 8.81661C0.86022 7.87498 1.87275 7.35907 2.81438 7.66502L10.2064 10.0668L9.09789 13.4785L1.70585 11.0767C0.764222 10.7708 0.248311 9.75824 0.554265 8.81661Z"
        fill={color}
      />
      <path
        d="M4.92733 22.2729C4.12633 21.6909 3.94856 20.5685 4.53052 19.7675L9.09905 13.4795L12.0012 15.588L7.43269 21.8761C6.85073 22.6771 5.72833 22.8548 4.92733 22.2729Z"
        fill={color}
      />
      <path
        d="M14.9023 13.4785L13.7938 10.0668L21.1858 7.66499C22.1275 7.35904 23.14 7.87495 23.446 8.81658C23.7519 9.75821 23.236 10.7707 22.2944 11.0767L14.9023 13.4785Z"
        fill={color}
      />
      <path
        d="M12.0005 15.5879L14.9027 13.4793L19.4712 19.7674C20.0531 20.5684 19.8754 21.6908 19.0744 22.2727C18.2734 22.8547 17.151 22.6769 16.569 21.8759L12.0005 15.5879Z"
        fill={color}
      />
    </svg>
  );
};

export default ActiveAiIcon;
